import { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Url from '../../../data/url';
import TopHeaderWithPrev from '../../../component/common/TopHeaderWithPrev';
import FullHeightContainer from '../../../component/common/FullHeightContainer';
import { reportApi } from '../../../assets/api/apis';
import moment from 'moment';
import toast from 'react-hot-toast';
import { TALENT_ARR } from '../../../data/define';
import IcFavorite from '../../../assets/image/ic_favorite.svg';
import IcFavoriteFilled from '../../../assets/image/ic_favorite_filled.svg'; // 하트가 채워진 아이콘이 필요함
import IcAnalysis from '../../../assets/image/ic_ai_report.svg';
import OneBtnAlert from '../../../component/common/OneBtnAlert';
import { useTranslation } from '../../../hook/useTranslation';

function WatchVideoPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();
  const { videoId, kidId } = location.state as { videoId: number; kidId: number };
  const [videoData, setVideoData] = useState<any>(null);
  const [isFavorite, setIsFavorite] = useState(false);
  const [alertOpen, setAlertOpen] = useState(false);

  useEffect(() => {
    if (!kidId || !videoId) return;
    const fetchVideoDetail = async () => {
      try {
        const videoRes: any = await reportApi.getIntelligenceCoreByVideo(videoId);
        if (videoRes.status === 200) {
          setVideoData(videoRes.data);
          setIsFavorite(videoRes.data.bookmark);
        }
      } catch (error) {
        console.error('Error fetching video detail:', error);
        toast.error(t('history.favorite.toast_load_fail'));
      }
    };
    fetchVideoDetail();
  }, [kidId, videoId, t]);

  const handleToggleFavorite = async () => {
    try {
      if (isFavorite) {
        const { status } = await reportApi.makeFavoriteVideo(videoId, false);
        if (status === 200 || status === 201) {
          setIsFavorite(false);
          toast.success(t('history.video.toast_favorite_removed'));
        }
      } else {
        const { status } = await reportApi.makeFavoriteVideo(videoId, true);
        if (status === 200 || status === 201) {
          setIsFavorite(true);
          toast.success(t('history.video.toast_favorite_added'));
        }
      }
    } catch (error) {
      console.error('Error toggling favorite:', error);
      toast.error(t('history.video.toast_favorite_error'));
    }
  };

  const handleGoToReport = () => {
    if (videoData?.reportId) {
      navigate(`${Url.Report}?reportId=${videoData.reportId}`);
    }
  };

  return (
    <FullHeightContainer>
      <TopHeaderWithPrev
        title={videoData ? moment(videoData.createdAt).format('YY.MM.DD') : ''}
        onClickPrev={() => navigate(-1)}
      />
      <div className="pageInner bg-[#FFF]" style={{ padding: 0 }}>
        {videoData && (
          <div className="w-full flex flex-col items-center justify-start h-[calc(100vh-60px)]">
            {/* 비디오 영역 */}
            <div className="w-full h-full bg-black flex items-center justify-center">
              <video
                src={videoData.mediaDetail?.mediaUrl}
                controls
                playsInline
                autoPlay
                className="w-full max-h-full"
              />
            </div>
            {/* 하단 정보 영역 */}
            <div
              className="absolute bottom-0 w-full bg-[rgba(0,0,0,0.5)] p-[20px] flex flex-col gap-[16px] backdrop-blur-[2px]"
              style={{ paddingBottom: '30px' }}
            >
              {/* 포착된 지능 */}
              <div className="flex items-center gap-[8px] flex-wrap">
                {videoData.intelligences?.map((intel: any, index: number) => {
                  const talent = TALENT_ARR.find((t) => t.id === intel.intelligence);
                  return (
                    <div
                      key={index}
                      className="px-[8px] py-[4px] rounded-[4px] text-[12px] font-[600] text-white border border-[rgba(255,255,255,0.4)] bg-[rgba(255,255,255,0.2)]"
                    >
                      {t(`talent.${talent?.key}`)}
                    </div>
                  );
                })}
              </div>
              {/* 리포트 핵심 텍스트 */}
              <div className="text-[14px] font-[400] text-white leading-[1.5]">
                {videoData.reportText || t('history.report_core.empty')}
              </div>
              {/* 액션 버튼 */}
              <div className="w-full flex items-center justify-end gap-[16px] mt-2">
                {/* <button
                  type="button"
                  className="flex flex-col items-center gap-[4px] cursor-pointer"
                  onClick={() => setAlertOpen(true)}
                >
                  <div className="w-[44px] h-[44px] rounded-full bg-[rgba(255,255,255,0.2)] flex items-center justify-center">
                    <img src={IcShare} alt="share" className="w-[20px] h-[20px]" />
                  </div>
                  <span className="text-[12px] font-[400] text-white">{t('history.video.share')}</span>
                </button> */}
                <button
                  type="button"
                  className="flex flex-col items-center gap-[4px] cursor-pointer"
                  onClick={handleToggleFavorite}
                >
                  <div className="w-[44px] h-[44px] rounded-full bg-[rgba(255,255,255,0.2)] flex items-center justify-center">
                    <img
                      src={isFavorite ? IcFavoriteFilled : IcFavorite}
                      alt="favorite"
                      className="w-[20px] h-[20px]"
                    />
                  </div>
                  <span className="text-[12px] font-[400] text-white">{t('history.video.favorite')}</span>
                </button>
                {videoData.reportId && (
                  <button
                    type="button"
                    className="flex flex-col items-center gap-[4px] cursor-pointer"
                    onClick={handleGoToReport}
                  >
                    <div className="w-[44px] h-[44px] rounded-full bg-[rgba(255,255,255,0.2)] flex items-center justify-center">
                      <img src={IcAnalysis} alt="report" className="w-[20px] h-[20px]" />
                    </div>
                    <span className="text-[12px] font-[400] text-white">{t('history.video.ai_report')}</span>
                  </button>
                )}
              </div>
            </div>
          </div>
        )}
      </div>
      <OneBtnAlert
        open={alertOpen}
        onClose={() => setAlertOpen(false)}
        title={t('history.video.share')}
        description={t('history.video.share_alert')}
        btnText={t('common.confirm')}
        onClick={() => setAlertOpen(false)}
      />
    </FullHeightContainer>
  );
}

export default WatchVideoPage;
